import React, {Fragment,Component} from "react";
import axios from "axios";
import exportToExcel from "../utils/ExcelUtils";

class LeadTrackingRow extends Component{
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: '',
            apiDetail: '/api/bankportal/report/detail/lead',
            reportName: 'ReportLeadTracking',
        }
        this.onCLickToExport = this.onCLickToExport.bind(this);
        this.exportToExcel = exportToExcel.bind(this);
        this.handlerClickNode = this.props.handlerClickNode.bind(this);
        this.handlerSetIsLoading = this.props.handlerSetIsLoading.bind(this);
    }

    componentDidMount() {

    }
    onCLickToExport = (item) => {
        const payload = {
            yyyymmdd: item?.yyyymmdd,
            code: item?.code,
            type: item?.type,
            parentId: item?.parentId
        }
        const { apiDetail, reportName } = this.state;
        this.handlerSetIsLoading(true);
        axios.post(apiDetail, payload)
            .then(response => {
                let data = [];
                if(!!response.data){
                    data.push([
                        "Ngày báo cáo"
                        ,"Mã số lead"
                        ,"Cập nhật tình trạng"
                        ,"Mã NVNH(FWD)"
                        ,"Mã NVNH(Ngân hàng)"
                        ,"Tên NVNH"
                        ,"Tên chi nhánh"
                        ,"Mã số chi nhánh (FWD)"
                        ,"Mã chi nhánh (Ngân hàng)"
                        ,"Tên phòng giao dịch"
                        ,"Mã phòng giao dịch (FWD)"
                        ,"Mã phòng giao dịch (Ngân hàng)"
                        ,"Mã người giới thiệu (theo mã HRM)"
                        ,"Mã Lãnh Đạo Phòng (HRM)"
                        ,"Mã số FSC"
                        ,"Họ và Tên khách hàng"
                        ,"Ngày sinh khách hàng"
                        ,"Số Passport/CC/CCCD/CMND"
                        ,"Số điện thoại khách hàng"
                        ,"Địa chỉ email khách hàng"
                        ,"Mối quan hệ của CBNH"
                        ,"Danh Xưng"
                        ,"Tình trạng hôn nhân"
                        ,"Nghề nghiệp"
                        ,"Thu nhập hàng tháng ước tính (triệu VNĐ)"
                        ,"Phân khúc khách hàng"
                        ,"Khách hàng từ sự kiện bán hàng"
                        ,"Sản phẩm chính"
                        ,"Sản phẩm  thứ 2"
                        ,"Sản phẩm  thứ 3"
                        ,"Khách hàng có đang trong thời hạn 60 ngày trước và 60 ngày sau ngày giải ngân toàn bộ khoản vay không?"
                        ,"Sản phẩm khách hàng có thể tham gia"
                        ,"Quan tâm của khách hàng"
                        ,"Khách hàng có đồng ý nhận tư vấn sản phẩm bảo hiểm"
                        ,"Cách thức tiếp cận khách hàng"
                        ,"KH đã từng mua BH nhân thọ trước đây"
                        ,"Ngày tạo lead"
                        ,"Ngày FSC nhận lead/mở lead"
                        ,"Ghi chú về đối tượng khách hàng"
                        ,"Ngày gọi"
                        ,"Cập nhật tình trạng tư vấn (có gặp được khách hàng hay không)"
                        ,"Số lần gọi"
                        ,"Ngày gọi thứ nhất"
                        ,"Ngày gọi thứ hai"
                        ,"Ngày gọi tiếp theo"
                        ,"Ngày gặp tư vấn"
                        ,"Kết quả hẹn gặp"
                        ,"Tổng số lần gặp"
                        ,"Ngày gặp thứ nhất"
                        ,"Ngày gặp thứ hai"
                        ,"Ngày gặp tiêp theo"
                        ,"Ngày gửi email"
                        ,"Tình  trạng gửi email"
                        ,"Ghi chú"
                        ,"Ngày tư vấn"
                        ,"Kết quả tư vấn"
                        ,"Ngày chốt Hợp đồng"
                        ,"Tình trạng chốt hợp đồng"
                        ,"Số hợp đồng"
                        ,"Nguồn khách hàng từ NVNH giới thiệu"
                        ,"FSC Định Danh lead"
                        ,"FYP dự kiến"
                    ]);
                    response?.data.map(item =>
                        data.push([
                            item?.reportDate
                            ,item?.refNo
                            ,item?.status
                            ,item?.bsCode
                            ,item?.bsCodeBank
                            ,item?.bsName
                            ,item?.boName
                            ,item?.boCode
                            ,item?.boCodeBank
                            ,item?.toName
                            ,item?.toCode
                            ,item?.toCodeBank
                            ,item?.introducerHrm
                            ,item?.hrm
                            ,item?.fscCode
                            ,item?.poName
                            ,item?.poBirthday
                            ,item?.poId
                            ,item?.poMobile
                            ,item?.poEmail
                            ,item?.customerRelationship
                            ,item?.title
                            ,item?.maritalStatus
                            ,item?.occupation
                            ,item?.income
                            ,item?.segmentLists
                            ,item?.customerEvent
                            ,item?.customerSource
                            ,item?.customerSourceTwo
                            ,item?.customerSourceThree
                            ,item?.inMonthLoan
                            ,item?.productCares
                            ,item?.interest
                            ,item?.allowToContact
                            ,item?.approach
                            ,item?.existPolicy
                            ,item?.createDate
                            ,item?.receiveDate
                            ,item?.note
                            ,item?.callDate
                            ,item?.callResult
                            ,item?.callTimes
                            ,item?.call1Date
                            ,item?.call2Date
                            ,item?.call3Date
                            ,item?.meetDate
                            ,item?.meetResult
                            ,item?.meetTimes
                            ,item?.meet1Date
                            ,item?.meet2Date
                            ,item?.meet3Date
                            ,item?.mailDate
                            ,item?.mailResult
                            ,item?.otherNote
                            ,item?.presentDate
                            ,item?.presentResult
                            ,item?.contractDate
                            ,item?.contractResult
                            ,item?.policyNumber
                            ,item?.leadSource
                            ,item?.lov
                            ,item?.estimatedFyp
                        ])
                    )
                }

                const exportName = item?.yyyymmdd+'_'+item?.code+'_'+item?.name+'_'+reportName;
                this.exportToExcel(data, exportName);
                this.handlerSetIsLoading(false);
            })
            .catch(error => {
                this.setState({ errorMessage: error.message });
                console.error('There was an error!', error);
                this.handlerSetIsLoading(false);
            });
    }
    render() {
        const {hasChild,isExpanded,marginLeftValue,data} = this.props;
        const iconStyle = {
            marginLeft: marginLeftValue+'px',
            boxShadow: 'none'
        }
        return (
            <Fragment>
            {
                !!data &&
                    <tr>
                        <td className={'bp-report-tree-node'}>
                            <button style={iconStyle} type="button" className={"btn"} onClick={this.handlerClickNode}>
                                {
                                    hasChild ?isExpanded?(' - '):(' + '):('   ')
                                }
                            </button>
                            <span>{ data?.name }</span>
                        </td>
                        <td className={"bp-report-td"}><span> { data?.c_refer?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_meet?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_advisor?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_close?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_refer_mtd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_meet_mtd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_advisor_mtd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_close_mtd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_refer_ytd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_meet_ytd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_advisor_ytd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_close_ytd?.toLocaleString() } </span></td>
                        <td className={'bp-report-button-export'}>
                            <button onClick={ () => this.onCLickToExport(data) } className={"btn btn-sm btn-info mt-1"}>Chi tiết</button>
                        </td>
                    </tr>

            }
            </Fragment>
        )
    }
}
export default LeadTrackingRow;